import React from 'react';
import classes from './index.module.scss';

/**
 * Props interface for the ProgressBar component
 */
interface Props {
	/** Percentage value (0-100) representing progress */
	valuePercentage: number;
}

/**
 * ProgressBar component
 * Renders a horizontal progress bar with customizable fill percentage
 * Used to visualize completion status, loading progress, etc.
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const ProgressBar = ({ valuePercentage }: Props) => {
	return (
		<div className={classes['progressBar']}>
			{/* Inner filled portion of the progress bar */}
			<div style={{ width: `${valuePercentage}%` }} className={classes['progressBar-inner']}></div>
		</div>
	);
};

export default ProgressBar;
